import React, { Component } from "react";
import {
  Grid,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Button,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";

import { createService } from "../../actions/ServiceAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
//import './ServiceStyle.css';
//import { REACT_URL_DASHBOARD,REACT_PATH_SERVICE_LIST } from "../../actions/ReactEndPoints";
import TimeLine from "../Layout/Breadcrumb";
import DevPortalLabel from "../Layout/DevPortalLabel";
import "./AddServiceStyle.css";
import { default as i18n } from "i18next";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { getServiceList } from "../../actions/ServiceAction";
class AddServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceName: "",
      serviceType: "",
      version: "",
      serviceUrl: "",
      tutorial: "",
      apiReference: "",
      apiPlayground: "",
      errors: {},
      error: false,
      hasError: false,
      role: "",

      status: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }
  onSubmit(e) {
    e.preventDefault();

    const newService = {
      serviceName: this.state.serviceName,
      serviceType: this.state.serviceType,
      version: this.state.version,
      serviceUrl: this.state.serviceUrl,
      tutorial: this.state.tutorial,
      apiReference: this.state.apiReference,
      apiPlayground: this.state.apiPlayground,
      status: this.state.status,
    };
    this.props.createService(newService, this.props.history);
  }
  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  handleClose = () => {
    this.setState({ open: false });
  };
  handleOpen = () => {
    this.setState({ open: true });
  };

  render() {
    const { t } = this.props;
    const { id } = this.props.match.params;
    const role = this.props.security.user.role;
    return (
      <div className="projects addServiceStyle">
        <DevPortalLabel></DevPortalLabel>
        <TimeLine path={t("createService")} page={"/dev/services/" + role} />
        <Grid container justify="center">
          <Grid item xs={10} sm={8} md={6} lg={4} xl={4}>
            <div className="addServiceBlock">
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography component="div">
                  <Box
                    justifyContent="center"
                    textAlign="center"
                    m={1}
                    color="white"
                    font="normal normal 600  Lato"
                    letterSpacing="0.8px"
                    fontSize="small"
                    opacity="1"
                  >
                    {t("createService")}
                  </Box>
                </Typography>
              </Box>
              <form onSubmit={this.onSubmit} autoComplete="off">
                <Box display="flex" justifyContent="center">
                  <TextField
                    error={this.state.errors.serviceName ? true : false}
                    helperText={this.state.errors.serviceName}
                    name="serviceName"
                    //id="serviceName"
                    value={this.state.serviceName}
                    onChange={this.onChange}
                    placeholder=""
                    id="custom-css-standard-input"
                    label={t("serviceName")}
                    inputProps={{
                      style: { textTransform: "uppercase" },
                      pattern: "^d*[a-zA-Z][a-zA-Z0-9 ]*$",
                      title: i18n.t("allowsAlphaNumeric"),
                    }}
                  />
                </Box>

                <Box display="flex" justifyContent="center">
                  <TextField
                    error={this.state.errors.serviceUrl ? true : false}
                    helperText={this.state.errors.serviceUrl}
                    name="serviceUrl"
                    //id="serviceUrl"
                    value={this.state.serviceUrl}
                    onChange={this.onChange}
                    placeholder=""
                    id="custom-css-standard-input"
                    label={t("serviceUrl")}
                  />
                </Box>

                <Box display="flex" justifyContent="center">
                  <TextField
                    error={this.state.errors.version ? true : false}
                    helperText={this.state.errors.version}
                    name="version"
                    //id="version"
                    value={this.state.version}
                    onChange={this.onChange}
                    placeholder=""
                    id="custom-css-standard-input"
                    label={t("version")}
                    inputProps={{
                      pattern: "^^(?:0|[0-9][0-9]*)(?:.(0|[0-9][0-9]*))*$",
                      title: i18n.t("versionAllowsNumsAndDots"),
                    }}
                  />
                </Box>
                <Box display="flex" justifyContent="center">
                  <FormControl>
                    <InputLabel id="demo-controlled-open-select-label">
                      {t("serviceType")}
                    </InputLabel>
                    <Select
                      error={!this.state.errors.serviceType ? false : true}
                      //helperText={this.state.errors.serviceType}
                      name="serviceType"
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      open={this.state.open}
                      onClose={this.handleClose}
                      onOpen={this.handleOpen}
                      value={this.state.serviceType}
                      onChange={this.onChange}
                    >
                      <MenuItem value="">
                        <em>{t("none")}</em>
                      </MenuItem>
                      <MenuItem value="PUBLIC">{t("public")}</MenuItem>
                      <MenuItem value="INTERNAL">{t("internal")}</MenuItem>
                    </Select>
                    <FormHelperText>
                      {this.state.errors.serviceType}
                    </FormHelperText>
                  </FormControl>
                </Box>
                <Box display="flex" justifyContent="center">
                  <FormControl>
                    <InputLabel id="demo-controlled-open-select-label">
                      {t("status")}
                    </InputLabel>
                    <Select
                      error={!this.state.errors.status ? false : true}
                      //helperText={this.state.errors.serviceType}
                      name="status"
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      open={this.state.open}
                      onClose={this.handleClose}
                      onOpen={this.handleOpen}
                      value={this.state.status}
                      onChange={this.onChange}
                    >
                      <MenuItem value="">
                        <em>{t("none")}</em>
                      </MenuItem>
                      <MenuItem value="CREATED">{t("created")}</MenuItem>
                      <MenuItem value="RELEASED">{t("released")}</MenuItem>
                      <MenuItem value="ABSOLUTE">{t("absolute")}</MenuItem>
                    </Select>
                    <FormHelperText>{this.state.errors.status}</FormHelperText>
                  </FormControl>
                </Box>
                <Box display="flex" justifyContent="center">
                  <TextField
                    error={this.state.errors.apiReference ? true : false}
                    helperText={this.state.errors.apiReference}
                    name="apiReference"
                    //id="apiReference"
                    value={this.state.apiReference}
                    onChange={this.onChange}
                    placeholder=""
                    id="custom-css-standard-input"
                    label={t("apiReference")}
                  />
                </Box>
                <Box display="flex" justifyContent="center">
                  <TextField
                    error={this.state.errors.apiPlayground ? true : false}
                    helperText={this.state.errors.apiPlayground}
                    name="apiPlayground"
                    //id="apiPlayground"
                    value={this.state.apiPlayground}
                    onChange={this.onChange}
                    placeholder=""
                    id="custom-css-standard-input"
                    label={t("apiPlayGround")}
                  />
                </Box>

                <Box display="flex" justifyContent="center">
                  <TextField
                    error={this.state.errors.tutorial ? true : false}
                    helperText={this.state.errors.tutorial}
                    name="tutorial"
                    //id="tutorial"
                    value={this.state.tutorial}
                    onChange={this.onChange}
                    placeholder=""
                    id="custom-css-standard-input"
                    label={t("tutorial")}
                  />
                </Box>

                <Box display="flex" justifyContent="center" p={3}>
                  <Box justifyContent="center" p={3}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      className="submitBtn"
                    >
                      {t("create")}
                    </Button>
                  </Box>
                  <Box justifyContent="center" p={3}>
                    <Button
                      variant="contained"
                      color="secondary"
                      className="go-forward"
                      component={Link}
                      to="/dev/services/INTERNAL_DEVELOPER"
                    >
                      {t("cancel")}
                    </Button>
                  </Box>
                </Box>
              </form>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}
AddServices.propTypes = {
  createService: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  security: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  serviceList: state.services.serviceList,
  errors: state.errors,
  security: state.security,
});
//export default  AddServices;
export default compose(
  withTranslation(),
  connect(mapStateToProps, { createService, getServiceList })
)(AddServices);
